<h2 mat-dialog-title>Compose PAYG Email</h2>

<mat-dialog-content class="email-dialog">

  <!-- Summary -->

  <div class="summary-card">

    <div class="summary-title">
      Recipients Selected
    </div>

    <div class="summary-count">
      {{ selectedRecipients.length }}
    </div>

  </div>

  <!-- Subject -->

  <mat-form-field appearance="outline" class="full-width">

    <mat-label>Subject</mat-label>

    <input matInput
           [(ngModel)]="subject"
           maxlength="250">

  </mat-form-field>

  <!-- Body -->

  <mat-form-field appearance="outline" class="full-width">

    <mat-label>Email Body</mat-label>

    <textarea matInput
              rows="16"
              [(ngModel)]="body">

    </textarea>

  </mat-form-field>

  <!-- Variables -->

  <div class="variable-section">

    <div class="section-title">

      Available Variables

    </div>

    <mat-chip-listbox>

      <mat-chip-option (click)="insertVariable('[BENEFICIARY_NAME]')">

        BENEFICIARY_NAME

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[URN]')">

        URN

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[EMAIL]')">

        EMAIL

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[PROBATE_ID]')">

        PROBATE_ID

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[ISSUE_DATE]')">

        ISSUE_DATE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[BEQUEST_TYPE]')">

        BEQUEST_TYPE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[ESTATE_VALUE]')">

        ESTATE_VALUE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[BEQUEST_VALUE]')">

        BEQUEST_VALUE

      </mat-chip-option>

      <mat-chip-option (click)="insertVariable('[VERIFICATION_DATE]')">

        VERIFICATION_DATE

      </mat-chip-option>

    </mat-chip-listbox>

  </div>

  <!-- Preview -->

  <div class="preview-section">

    <div class="section-title">

      Preview
      <span class="preview-note">

        (using first selected recipient)

      </span>

    </div>

    <div class="preview-box">

      <div class="preview-subject">

        <strong>Subject</strong>

        <div>

          {{previewSubject}}

        </div>

      </div>

      <hr>

      <div class="preview-body">

        <strong>Body</strong>

        <pre>{{previewBody}}</pre>

      </div>

    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">

  <button mat-button
          mat-dialog-close>

    Cancel

  </button>

  <button mat-stroked-button
          color="primary"
          (click)="updatePreview()">

    Preview

  </button>

  <button mat-raised-button
          color="primary"
          (click)="sendEmails()">

    Send Emails

  </button>

</mat-dialog-actions>
